// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"312":"2f62bbc4","551":"f764e26e","842":"d3956ad6"}[chunkId] + ".chunk.js";
};